import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_900, LILAC_100, LILAC_800, StateConfigContext, useBreakpoint } from '@airtel/air-design-system';
import { useContext } from 'react';
import { Pressable } from 'react-native';
import { TypographyWidget } from '../../../typography-widget';
import { getSchedulingCarouselItemStyles } from './SchedulingCarouselItemStyles';
export var SchedulingCarouselItem = props => {
  var _props$carouselItem = props.carouselItem,
    carouselItem = _props$carouselItem === void 0 ? {} : _props$carouselItem,
    carouselIndex = props.carouselIndex,
    isLastItem = props.isLastItem,
    onSelectCarousel = props.onSelectCarousel;
  var title = carouselItem.title,
    subtitle = carouselItem.subtitle,
    _carouselItem$isDisab = carouselItem.isDisabled,
    isDisabled = _carouselItem$isDisab === void 0 ? false : _carouselItem$isDisab,
    _carouselItem$isSelec = carouselItem.isSelected,
    isSelected = _carouselItem$isSelec === void 0 ? false : _carouselItem$isSelec;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var schedulingCarouselItemStyles = getSchedulingCarouselItemStyles(isLargeScreen, isSelected, theme);
  var titleType = isLargeScreen ? 'h6' : 'body-single-line-xl';
  var subtitleType = isLargeScreen ? 'body-single-line-md' : 'body-single-line-sm';
  var colorType = BLACK_900;
  if (isSelected) {
    colorType = LILAC_100;
  } else if (isDisabled) {
    colorType = LILAC_800;
  }
  return _jsxs(Pressable, Object.assign({
    style: [schedulingCarouselItemStyles.carouselCardContainer, !isLastItem && schedulingCarouselItemStyles.carouselCardContainerSpacing],
    onPress: () => onSelectCarousel(carouselItem, carouselIndex),
    disabled: isDisabled
  }, {
    children: [_jsx(TypographyWidget, {
      text: title,
      color: colorType,
      type: titleType,
      disabled: isDisabled
    }), _jsx(TypographyWidget, {
      text: subtitle,
      color: colorType,
      type: subtitleType,
      disabled: isDisabled
    })]
  }));
};